export const environment = {
  version: 0,
  APIBaseUrl: 'https://pickright.in',
  token: 'marsAdminToken',
  routePrefix: 'cas'
};